export default __webpack_public_path__ + "static/media/mobile-app-homepage-mockup.25620769.png";